import React from "react";
import { Button, Tooltip, Space } from "antd";
import { RedoOutlined } from "@ant-design/icons";
import ProcessingButton from "@/components/ui/ProcessingButton";

function SectionPageButtonContainer({
  sectionGeneration,
  selectedText,
  handleSpecificRegeneration,
  handleSectionGeneration,
  selectedSections,
  setActiveTabId,
  SearchOutlined,
}) {
  return (
    <div className="main_button_conatiner">
      {!sectionGeneration && (
        // <div style={{ width: '45px' }}></div>
        <Tooltip
          placement="bottom"
          title={`${selectedText ? "Select Text for Regeneration" : "Regenerate Selected Text"}`}
        >
          <Button
            className={`default_button ${selectedText ? "disabled" : ""}`}
            onClick={handleSpecificRegeneration}
            disabled={selectedText || true}
            style={{ display: "none" }}
          >
            <RedoOutlined />
          </Button>
        </Tooltip>
      )}
      <div>
        <ProcessingButton
          onClick={handleSectionGeneration}
          isProcessing={sectionGeneration}
          processingText="Generating Sections..."
          renderButton={({ onClick, disabled, className, isProcessing }) => (
            <Button
              className={`${className} default_button ${selectedSections.length === 0 ? "disabled" : ""}`}
              onClick={onClick}
              disabled={disabled || selectedSections.length === 0}
              style={{ margin: "4px 0" }}
            >
              <Space size={6}>
                <img
                  src="/assets/icon-32.png"
                  alt="Section Icon"
                  style={{ width: "20px", height: "20px" }}
                />
                <span className={isProcessing ? "ai-processing-label" : undefined}>
                  {isProcessing ? "Generating Sections..." : "Generate Sections"}
                </span>
              </Space>
            </Button>
          )}
        />
        <p
          style={{
            color: "#d1d1d1",
            fontSize: "10px",
            textAlign: "center",
            margin: 0,
            marginTop: "2px",
            marginBottom: "4px",
          }}
        >
          AI-generated content may be incorrect
        </p>
      </div>
      {!sectionGeneration && (
        <Tooltip placement="bottom" title="Search documents">
          <Button className="default_button" onClick={() => setActiveTabId("chat")} style={{ display: "none" }}>
            <SearchOutlined />
          </Button>
        </Tooltip>
      )}
    </div>
  );
}

export default SectionPageButtonContainer;
